// extracted by mini-css-extract-plugin
module.exports = {"editor":"rich_text-module_editor_6a5aa","label":"rich_text-module_label_08bf7"};